import { render, staticRenderFns } from "./PasswordResetForm.vue?vue&type=template&id=716b8e9c&scoped=true"
import script from "./PasswordResetForm.vue?vue&type=script&lang=js"
export * from "./PasswordResetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716b8e9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('716b8e9c')) {
      api.createRecord('716b8e9c', component.options)
    } else {
      api.reload('716b8e9c', component.options)
    }
    module.hot.accept("./PasswordResetForm.vue?vue&type=template&id=716b8e9c&scoped=true", function () {
      api.rerender('716b8e9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/PasswordResetForm.vue"
export default component.exports